var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeco2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.8394 -10V25.5798C15.6725 25.5798 0.116791 9.64004 0.116791 -10H34.8394Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.8394 25.5801V61.1598C54.0063 61.1598 69.562 45.2201 69.562 25.5801H34.8394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.8394 -10C54.0063 -10 69.562 5.93974 69.562 25.5798H34.8394V-10Z",
    fill: "#FE5E33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco2);
export default __webpack_public_path__ + "static/media/deco2.438ab68421e61bd610c2e05465842046.svg";
export { ForwardRef as ReactComponent };